import { Inject, Injectable } from '@angular/core';
import { Row } from '@vendasta/galaxy/table';
import { MatDialog } from '@angular/material/dialog';
import { GalaxyFilterInterface } from '@vendasta/galaxy/filter/chips';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CampaignConfig } from '@galaxy/campaign/dependencies';
import { take } from 'rxjs/operators';
import { CONFIG_TOKEN } from './tokens';

@Injectable({ providedIn: 'root' })
export class CrmCampaignContactsDialogService {
  constructor(
    private dialog: MatDialog,
    @Inject('PARTNER_ID') readonly partnerId$: Observable<string>,
    private router: Router,
    @Inject(CONFIG_TOKEN) private config: CampaignConfig,
  ) {}

  navigateToSendCampaign(
    rows: Row[],
    filters?: GalaxyFilterInterface[],
    search?: string,
    useSelectAll?: boolean,
    totalContacts?: number,
  ): void {
    const contactQueryString = encodeURIComponent('[' + rows.map((c) => c.id).join(',') + ']');
    const filtersQueryString = encodeURIComponent(filters ? JSON.stringify(filters) : '');
    const searchQueryString = encodeURIComponent(search || '');
    const useSelectAllQueryString = encodeURIComponent(useSelectAll || false);
    const totalContactsQueryString = totalContacts || 0;
    const backUrl = encodeURIComponent(this.router.url);
    const queryString = `contactIds=${contactQueryString}&backUrl=${backUrl}&filters=${filtersQueryString}&search=${searchQueryString}&useSelectAll=${useSelectAllQueryString}&totalContacts=${totalContactsQueryString}`;

    this.config.basePath$.pipe(take(1)).subscribe((basePath) => {
      this.router.navigateByUrl(`${basePath}/preview-send?${queryString}`);
    });
  }
}
